import { ConnectionHandler } from "relay-runtime"
import { AppointmentEdges } from "@/modules/patients/services/usePatientAgenda"
import { ExtractNode } from "@/modules/patients/types/ExtractNode"

type PatientAppointment = AppointmentEdges

type Appointment = ExtractNode<PatientAppointment>

const connectionKey = "patientIdConnection_appointments"
const getPatientConnectionId = (patientId: string) => {
  return ConnectionHandler.getConnectionID(patientId, connectionKey)
}

export { getPatientConnectionId, type Appointment, type PatientAppointment }
